import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface AddStickyNoteProps {
  text: string;
  onDelete?: () => void;
  onEdit?: () => void;
}
export const AddMemoNote = ({ text, onDelete, onEdit }: AddStickyNoteProps) => {
  const { isEditable } = useContext(CreateArtifactContext);
  return (
    <div className="relative flex flex-col w-full md:max-w-[480px] py-7">
      {isEditable && (
        <div className="absolute top-0 right-0 flex flex-row gap-3">
          <div className="content-center w-5 h-5 align-middle shadow-md top-1 right-1 rounded-3xl bg-slate-600">
            <button className="absolute top-0 left-0 right-0 w-5 h-5 text-white " onClick={onDelete}>
              ×
            </button>
          </div>
          <div className="content-center w-5 h-5 align-middle shadow-md top-8 right-1 rounded-3xl bg-slate-600">
            <button className="relative flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600" onClick={onEdit}>
              ✎
            </button>
          </div>
        </div>
      )}
      <div className="flex items-center justify-center rectangle-class">
        <p className="rectangle-text  align-middle font-black text-xl content-center gap-[30dp]">
          <pre
            className="max-w-full p-2 overflow-auto break-words whitespace-pre-wrap rounded-md"
            style={{ fontFamily: "inherit", fontSize: "inherit", overflowWrap: "break-word", maxWidth: "100%" }}
          >
            {text}
          </pre>
        </p>
      </div>
    </div>
  );
};

// .location_dtpic_title {
//   @apply font-roboto font-normal  text-[17px] leading-[22px] tracking-[0.36px] text-[#000000] text-wrap h-10 px-2 py-1 border rounded;
// }

// .rectangle-text {
//   @apply w-full h-full font-roboto font-normal text-[14px] leading-[18.2px] tracking-[0.36px] rounded-[12px] p-[15px];
// }
